import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import CustomButton from "common/components/Button/Button"
import { useTranslation } from "react-i18next"
import "../../../pages/PerfilEmpresa/perfilEmpresa.scss"
import { MODES_MODAL_VARIFICACION } from "./constant"

const VerificarEmpresaNotification = ({
  empresaActivaRazonSocial,
  onHide,
  onSubmit,
  mode,
  errorInfo,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return mode === MODES_MODAL_VARIFICACION.VALIDAR ? (
    <div className='tw-w-[432px] tw-mx-[40px] tw-mt-10 '>
      <div className='tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center'>
        <div className='tw-w-[175px] tw-flex tw-flex-col tw-items-center tw-justify-center tw-mb-4'>
          <div className='tw-rounded-full tw-w-24 tw-h-24 tw-bg-simple-20'>
            <div className='tw-rounded-full tw-w-16 tw-h-16 tw-flex tw-justify-center tw-items-center tw-border tw-border-solid tw-border-simple-90 tw-border-opacity-10 tw-mx-4 tw-my-4'>
              <div className='tw-rounded-full tw-w-8 tw-h-8 tw-m-auto'>
                <FontAwesomeIcon
                  icon={["fal", "circle-info"]}
                  className='tw-w-8 tw-h-8 tw-text-info'
                />
              </div>
            </div>
          </div>

          <div className='tw-font-roboto tw-text-2xl tw-font-medium tw-text-left'>
            {t("perfilEmpresa.company.modalValidate.title")}
          </div>
        </div>
        <div className='tw-w-full tw-flex tw-flex-col'>
          <div className='tw-h-[21px] tw-mb-6 tw-text-center'>
            {t("perfilEmpresa.company.modalValidate.subtitle")}
          </div>
          <div className='tw-w-full tw-h-14 tw-bg-info-10 tw-font-medium tw-flex tw-justify-center tw-items-center'>
            {empresaActivaRazonSocial}
          </div>
          <div className='tw-mt-6'>
            <p className='m-0'>
              {t("perfilEmpresa.company.modalValidate.text1")}{" "}
              <span className='tw-font-bold'>
                {t("perfilEmpresa.company.modalValidate.text1Bold")}{" "}
              </span>
              {t("perfilEmpresa.company.modalValidate.text11")}
            </p>
          </div>
          <div className='tw-mt-4'>
            <p className='m-0'>
              {t("perfilEmpresa.company.modalValidate.text2")}{" "}
              <a
                href={import.meta.env.REACT_APP_INSTALAR_FICHEROS_URL}
                className='tw-underline tw-text-info-25 tw-cursor-pointer'
                target='_blank'
                rel='noopener noreferrer'
              >
                {t("perfilEmpresa.company.modalValidate.text2Bold")}
              </a>
            </p>
          </div>
        </div>
      </div>
      <div className='tw-w-full tw-flex tw-justify-between tw-my-6'>
        <CustomButton
          label={`${t("perfilEmpresa.company.modalValidate.labelCancel")}`}
          className='tw-w-52 tw-h-12 !tw-bg-transparent !tw-text-primary !tw-border-0'
          onClick={onHide}
        />
        <CustomButton
          label={`${t("perfilEmpresa.company.modalValidate.labelAccept")}`}
          className='tw-w-52 tw-h-12 !tw-bg-primary tw-text-simple-10'
          type='submit'
          onClick={onSubmit}
        />
      </div>
    </div>
  ) : (
    <div className='tw-w-[368px] tw-mx-[40px] tw-mt-10 '>
      <div className='tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center'>
        <div className='tw-w-[237px] tw-flex tw-flex-col tw-items-center tw-justify-center tw-mb-4'>
          <div className='tw-rounded-full tw-w-24 tw-h-24 tw-bg-simple-20'>
            <div className='tw-rounded-full tw-flex tw-justify-center tw-items-center tw-w-16 tw-h-16 tw-border tw-border-solid tw-border-simple-90 tw-border-opacity-10 tw-mx-4 tw-my-4'>
              <div className='tw-rounded-full tw-w-8 tw-h-8'>
                <FontAwesomeIcon
                  icon={["fal", "triangle-exclamation"]}
                  className='tw-w-8 tw-h-7 tw-text-danger'
                />
              </div>
            </div>
          </div>

          <div className='tw-font-roboto tw-text-2xl tw-font-medium tw-text-left'>
            {t("perfilEmpresa.company.modalValidate.titleError")}
          </div>
        </div>
        <div className='tw-w-full tw-flex tw-flex-col'>
          {!errorInfo ? (
            <div className='tw-h-[21px] tw-mb-6 tw-text-center'>
              {t("perfilEmpresa.company.modalValidate.subtitleOneError")}
            </div>
          ) : (
            <div className='tw-h-auto tw-text-center'>{errorInfo}</div>
          )}
          <div className='tw-mt-6'>
            <p className='m-0'>
              {t("perfilEmpresa.company.modalValidate.textFinalError")}{" "}
              <span className='tw-font-bold tw-text-danger'>
                {t("perfilEmpresa.company.modalValidate.textFinalBoldError")}
              </span>
              {t("perfilEmpresa.company.modalValidate.textFinal2Error")}
            </p>
          </div>
        </div>
      </div>
      <div className='tw-w-full tw-flex tw-justify-between tw-my-6'>
        <CustomButton
          label={`${t("perfilEmpresa.company.modalValidate.continueLabel")}`}
          className='tw-w-full tw-h-12 !tw-bg-primary tw-text-simple-10'
          type='submit'
          onClick={onSubmit}
        />
      </div>
    </div>
  )
}

export default VerificarEmpresaNotification
